import { Box, Drawer, List, Toolbar } from '@mui/material'
import sizeConfigs from '../../configs/SizeConfigs'
import appRoutes from '../../routes/appRoutes'
import SidebarItem from './SidebarItem'
import SidebarItemCollapse from './SidebarItemCollapse'
import Copyright from './Copyright'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

const Sidebar = () => {
  const { isTokenAuth } = useSelector((state) => state.auth)

  const routesToRender = useMemo(() => {
    if (isTokenAuth) {
      const allowedPaths = ['/admet', '/SolPred', '/Drugex', '/docs']
      return appRoutes.filter((route) =>
        allowedPaths.some(path =>
          route.path.toLowerCase() === path.toLowerCase()
        )
      )
    }
    return appRoutes
  }, [isTokenAuth])

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: sizeConfigs.sidebar.width,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: sizeConfigs.sidebar.width,
        },
      }}
    >
      <Toolbar />
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
          justifyContent: 'space-between',
        }}
      >
        <List>
          {routesToRender.map((route, index) =>
            route.sidebarProps ? (
              route.child ? (
                <SidebarItemCollapse item={route} key={index} />
              ) : (
                <SidebarItem item={route} key={index} />
              )
            ) : null,
          )}
        </List>
        <Copyright />
      </Box>
    </Drawer>
  )
}
export default Sidebar
